import React from 'react'
import Header  from '../../components/Header'
import { Toast, Modal } from 'antd-mobile';
import './song.less'
import { getUrl } from '../../utils/deciphering'
import wx from 'weixin-js-sdk'

import sendGiftImg from '../../images/diary/diary_btn_sendgift.png'
import tryImg from '../../images/diary/diary_btn_try.png'
import otherdiaryImg from '../../images/diary/diary_btn_otherdiary.png'
import playImg from '../../images/diary/diary_play.png'
import pauseImg from '../../images/diary/diary_pause.png'
import bgImg from '../../images/diary/diary_song_bg.png'
import joinImg from '../../images/diary/diary_join_btn.png'

import { getDiaryMission, addPraise, getDiaryActivityData } from '../../api/diary'
import { isWeChat, getQueryString, jumpApp, getNickName, timeFormat,formatMTime, getAllTime } from '../../utils/utils'
import ShareShadeLayer from '../../components/Sound/shareShadeLayer'
import Share from '../../components/Sound/share'
import { advert } from '../../api/count'
import { getShareContent } from '../../api/share'
import Cookies from 'js-cookie'
import DocumentTitle from 'react-document-title'
import { global } from '../../config/index'
import { getWithdrawRole} from '../../api/hcFission'


export default class DiarySongIndex extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
        data: {},
        paused: true,
        isFinished:false,
    }
  }

  componentDidMount() {
      this.requestList()
      this.initPlay()
      this.baiduStatistics();
      this.handlePageCounts();
  }

  //百度统计
  baiduStatistics() {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?18fd37d414145c525285e6cf0f11dada";
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
    })();
  }
  //页面访问量
  handlePageCounts() {
    setTimeout(function(){
      window._hmt.push(['_trackEvent', "diary_song", "visit", "diary_song_visit",1]);
    },500)
  }

  //记录用户行为事件点击统计
  handleUserAction = (pageName,action,actionDetail) => {
    window._hmt.push(['_trackEvent', pageName, action, actionDetail,1]);
   }
  requestList = ()=>{
      getDiaryActivityData({}).then((res)=>{
      //console.log(res)
      this.setState({
        data: res
      }, () => {
        if (this.state.client == 1) {
          this.handleGetShareContent({})
        }
      })
    })

  }

  initPlay = () => {
    let audio = this.refs.audio
    let _this = this

    //开始播放：
    audio.onplay = function () {
       _this.setState({
         paused: false
       })
    }

    //暂停播放：
    audio.onpause = function () {
       _this.setState({
        paused: true
       })
    }

  }

  audioPlay = () => {
    let audio = this.refs.audio
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  }

  handlegoRecord = () => {
     jumpApp({opentype:'app_within', openvar: 'squareAudio'})
  }

  handlegoSquare = () => {
     jumpApp({opentype:'app_within', openvar: 'square'})
  }
  
  handleDownload = () => {
    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.saker.app.huhu&ckey=CK1404130488352'
  }

  render() {
      let { data, paused } = this.state
        return (
            <DocumentTitle title={ data && data.diary_activity ? data.diary_activity.name : '呼呼收音机'}>
                  <div className="mainSong">
                    <div className="songContainer">
                        {
                            data && data.diary_activity ?
                            <div className="album-img">
                              <img src={data && data.diary_activity ? data.diary_activity.image : ''} alt="" />
                            <div className="diary-control">
                            <div className="play-btn">
                              <img onClick={this.audioPlay}
                                      src={ paused ? playImg: pauseImg}
                                      alt=""/>
                            </div>
                            </div>
                            </div>
                                : ''
                          }
                    </div>

                  <div className="songBottomView">
                    <div className="userHeader">
                      <img src={data && data.diary_activity ? data.diary_activity.icon : ''} alt="" />
                      <div className="label">{data && data.diary_activity ? data.diary_activity.msg : ''}</div>
                    </div>
                    <div className="joinView">
                      <img src={joinImg} alt="" />
                        {data && data.diary_activity && data.diary_activity.isnew == 1 ?
                            <div className="joinTitle" onClick={this.handlegoRecord}>{"立即参与"}</div>
                            : <div className="joinTitle" onClick={this.handlegoSquare}>{"前往广场"}</div>
                        }
                    </div>
                    <div className="time">活动时间：{data && data.diary_activity ? data.diary_activity.date : ''}</div>
                    <div className="activityDetail">
                       <div className="detail" dangerouslySetInnerHTML={{ __html: data && data.diary_activity ? data.diary_activity.rule : ''}}></div>
                    </div>
                  </div>
                  <audio ref="audio" src={data && data.diary_activity ? data.diary_activity.mp3 : '' }
                         style={{display: 'none'}}>
                    Your browser does not support the audio element.
                  </audio>
              </div>
            </DocumentTitle>
        );
  }

}


// WEBPACK FOOTER //
// ./src/pages/diary/song.js